import React, { useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import useCursorStore from "../store/cursorStore";

gsap.registerPlugin(useGSAP);

export default function CreditsUI() {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef();
  const overlayRef = useRef();
  const buttonRef = useRef();
  const { setCursorScale } = useCursorStore.getState();

  const openPopup = () => {
    setIsOpen(true);
    gsap.set([overlayRef.current, popupRef.current], { display: "flex" });
    gsap.to(buttonRef.current, { opacity: 0, duration: 0.2 });
    gsap.to(overlayRef.current, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    });
    gsap.fromTo(
      popupRef.current,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 0.4, ease: "back.out(1.2)" }
    );
  };

  const closePopup = () => {
    gsap.to(overlayRef.current, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
    });
    gsap.to(buttonRef.current, { opacity: 1, duration: 0.2, delay: 0.2 });
    gsap.to(popupRef.current, {
      opacity: 0,
      scale: 0.9,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        setIsOpen(false);
        gsap.set([overlayRef.current, popupRef.current], { display: "none" });
      },
    });
  };

  return (
    <>
      {/* Bouton permanent en bas à gauche */}
      <button
        className="creditsUI__button button"
        ref={buttonRef}
        onClick={openPopup}
        onPointerEnter={() => setCursorScale(2.5)}
        onPointerLeave={() => setCursorScale(1)}
      >
        <svg width="101" height="48" viewBox="0 0 101 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M83.351 1.42937C89.6042 4.95399 93.2566 10.7481 96.1116 15.5C99.5913 21.2918 103.597 33.4365 98.1464 38.7061C92.6345 44.035 78.5078 42.7177 68.0876 44.3708C60.1725 45.6266 52.774 47.0306 44.5668 47.2065C34.32 47.4261 21.9848 49.6509 14.7033 45.515C7.42507 41.381 7.20511 37.7518 5.14559 32C2.92889 25.8092 -2.86875 16.313 2.24167 10.7124C7.36558 5.09695 22.3701 6.68954 32.9796 4.89823C41.1696 3.51543 48.749 0.830363 57.223 1.42937C65.8748 2.04095 77.1371 -2.07312 83.351 1.42937Z" fill="white"/>
        </svg>
        Crédits
      </button>

      {/* Overlay (fond sombre) */}
      <div
        className="creditsUI__overlay"
        ref={overlayRef}
        onClick={closePopup}
      />

      {/* Popup */}
      <div className="creditsUI__popup" ref={popupRef}>
        <svg width="420" height="485" viewBox="0 0 420 485" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M362.621 13.6088C388.834 47.1661 377.153 182.232 389.121 227.474C403.708 282.617 434.199 373.316 411.351 423.487C388.245 474.223 329.027 461.681 285.347 477.42C252.167 489.376 196.525 475.746 162.121 477.42C119.167 479.511 67.4591 500.693 36.9357 461.316C6.42587 421.956 26.7542 305.236 18.1209 250.474C8.82862 191.532 -12.0966 122.287 9.32591 68.9639C30.8049 15.5003 93.7025 30.6631 138.177 13.6084C172.509 0.442941 217.572 7.90575 253.094 13.6088C289.362 19.4315 336.573 -19.7378 362.621 13.6088Z" fill="white"/>
        </svg>

        <button
          className="creditsUI__popup__close"
          onClick={closePopup}
          onPointerEnter={() => setCursorScale(2.5)}
          onPointerLeave={() => setCursorScale(1)}
        >
          Fermer
        </button>
        <div className="creditsUI__popup__content">
          <span>Développeur</span>  
          <h2>Killian El Attar</h2>
          <span>Designers</span>  
          <h2>Victor Goujon</h2>
          <h2>Hugo Feige</h2>
          <h2>Axel Sagrado</h2>
          <span>Voix off</span>  
          <h2>Superflamme (Le grand père)</h2>
          <h2>Amélia dnty (la guide)</h2>
          <h2>Mathis Thouin (l’enfant)</h2>
        </div>
      </div>
    </>
  );
}
